/** @format */

import React, { FunctionComponent } from 'react';
import { ProductRemoveType } from './ProductRemove';
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import I18n from '../../../components/Translate/I18n';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import CustomTextButtom from '../../../components/Buttons/CustomTextButton';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { useDispatch } from 'react-redux';
import { ProductActions } from '../../../modules/simcard/ProductReducer';

type ProductBreakRemoveType = ProductRemoveType & { open: boolean; setOpenDialog: (open: boolean) => void };

export const ProductBreakRemove: FunctionComponent<ProductBreakRemoveType> = ({ classes, product, itemLoader, open, setOpenDialog }) => {
    const dispatch = useDispatch();
    const confirmBreakDelete = (): void => {
        itemLoader.putWithCallback(
            FormGeneralHelper.getUrl('/operation_on_sim_cards/' + product.id),
            'deleted_product_setup_no_dispatch',
            {
                id: product.id,
                deleteCancel: true,
            },
            (): void => {
                setOpenDialog(false);
                dispatch({ type: ProductActions.PRODUCT_REFRESH_VIEW, uri: product['@id'] });
            }
        );
    };
    const rejectBreakDelete = (): void => {
        setOpenDialog(false);
    };

    return (
        <Dialog open={open} onClose={rejectBreakDelete} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">
                <I18n trans="simcard:edit.planned_delete_sim_card" />
            </DialogTitle>
            <DialogContent>
                <GridContainer>
                    <GridItem xs={12}>
                        <Typography variant="subtitle1">
                            <I18n trans="simcard:edit.confirm_cancel_delete_process" />
                        </Typography>
                    </GridItem>
                    <GridItem xs={12}>
                        <I18n trans="simcard:edit.confirm_cancel_delete_process_additional_info" />
                    </GridItem>
                </GridContainer>
            </DialogContent>
            <DialogActions>
                <CustomTextButtom callback={rejectBreakDelete} callbackParam={{}} label="general:common.cancel" size="sm" />
                <CustomTextButtom callback={confirmBreakDelete} callbackParam={{}} label="simcard:edit.send_cancel" size="sm" />
            </DialogActions>
        </Dialog>
    );
};
